// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LegalRestriction } from "./LegalRestriction";
import {
  LegalRestrictionFromJSON,
  LegalRestrictionFromJSONTyped,
  LegalRestrictionToJSON,
  LegalRestrictionToJSONTyped,
} from "./LegalRestriction";
import type { ResponsibleParty } from "./ResponsibleParty";
import {
  ResponsiblePartyFromJSON,
  ResponsiblePartyFromJSONTyped,
  ResponsiblePartyToJSON,
  ResponsiblePartyToJSONTyped,
} from "./ResponsibleParty";
import type { CitationUpdate } from "./CitationUpdate";
import {
  CitationUpdateFromJSON,
  CitationUpdateFromJSONTyped,
  CitationUpdateToJSON,
  CitationUpdateToJSONTyped,
} from "./CitationUpdate";
import type { ISO6392B } from "./ISO6392B";
import {
  ISO6392BFromJSON,
  ISO6392BFromJSONTyped,
  ISO6392BToJSON,
  ISO6392BToJSONTyped,
} from "./ISO6392B";
import type { StatusCode } from "./StatusCode";
import {
  StatusCodeFromJSON,
  StatusCodeFromJSONTyped,
  StatusCodeToJSON,
  StatusCodeToJSONTyped,
} from "./StatusCode";

/**
 * A value object for updating ISO19115 datasets.
 * @export
 * @interface ISO19115DatasetUpdate
 */
export interface ISO19115DatasetUpdate {
  /**
   * Taal gebruikt om de metadata te beschrijven.
   */
  language?: ISO6392B | null;
  /**
   * Conditioneel indien een dataset (serie) met hogere hierarchie bestaat.
   */
  parentIdentifier?: string | null;
  /**
   *
   */
  metadataContact?: ResponsibleParty | null;
  /**
   * The Coordinate Reference System as an EPSG code, for example: 'EPSG:123456'. Raster transformations are done using PROJ4 version 9.6.0.
   */
  spatialReferenceSystem?: string | null;
  /**
   *
   */
  dataCitation?: CitationUpdate | null;
  /**
   * Korte beschrijving van de inhoud van de dataset.
   */
  _abstract?: string | null;
  /**
   * Het doel van de dataset.
   */
  purpose?: string | null;
  /**
   * Status van de dataset.
   */
  status?: StatusCode | null;
  /**
   *
   */
  dataContact?: ResponsibleParty | null;
  /**
   * Toepassingen waarvoor de data niet geschikt is.
   */
  useLimitations?: Array<string> | null;
  /**
   * Juridische beperkingen voor het gebruik van de data.
   */
  legalRestrictions?: Array<LegalRestriction> | null;
  /**
   * De beoogde schaal waarop het bestand waarheidsgetrouw gebruikt mag worden. Dit moet een positief numeriek getal zijn.
   */
  equivalentScale?: number | null;
  /**
   * De resolutie van de dataset in meters.
   */
  resolution?: number | null;
  /**
   * Taal waarmee de dataset beschreven is.
   */
  dataLanguage?: ISO6392B | null;
  /**
   * Hoofdthema's van de dataset.
   */
  topicCategory?: Array<string> | null;
  /**
   * De coördinaten dienen te worden weergegeven volgens referentiesysteem WGS 84.
   */
  spatialExtent?: Array<Array<number>> | null;
  /**
   * Algemene beschrijving of opmerking, betreffend de geschiedenis van de bron. Dit kunnen ook beschrijvingen of opmerkingen zijn over de brongegevens en/of het productieproces.
   */
  dataLineage?: string | null;
}

/**
 * Check if a given object implements the ISO19115DatasetUpdate interface.
 */
export function instanceOfISO19115DatasetUpdate(value: object): value is ISO19115DatasetUpdate {
  return true;
}

export function ISO19115DatasetUpdateFromJSON(json: any): ISO19115DatasetUpdate {
  return ISO19115DatasetUpdateFromJSONTyped(json, false);
}

export function ISO19115DatasetUpdateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ISO19115DatasetUpdate {
  if (json == null) {
    return json;
  }
  return {
    language:
      json["language"] === undefined
        ? undefined
        : json["language"] === null
        ? null
        : ISO6392BFromJSON(json["language"]),
    parentIdentifier:
      json["parent_identifier"] === undefined
        ? undefined
        : json["parent_identifier"] === null
        ? null
        : json["parent_identifier"],
    metadataContact:
      json["metadata_contact"] === undefined
        ? undefined
        : json["metadata_contact"] === null
        ? null
        : ResponsiblePartyFromJSON(json["metadata_contact"]),
    spatialReferenceSystem:
      json["spatial_reference_system"] === undefined
        ? undefined
        : json["spatial_reference_system"] === null
        ? null
        : json["spatial_reference_system"],
    dataCitation:
      json["data_citation"] === undefined
        ? undefined
        : json["data_citation"] === null
        ? null
        : CitationUpdateFromJSON(json["data_citation"]),
    _abstract:
      json["abstract"] === undefined
        ? undefined
        : json["abstract"] === null
        ? null
        : json["abstract"],
    purpose:
      json["purpose"] === undefined ? undefined : json["purpose"] === null ? null : json["purpose"],
    status:
      json["status"] === undefined
        ? undefined
        : json["status"] === null
        ? null
        : StatusCodeFromJSON(json["status"]),
    dataContact:
      json["data_contact"] === undefined
        ? undefined
        : json["data_contact"] === null
        ? null
        : ResponsiblePartyFromJSON(json["data_contact"]),
    useLimitations:
      json["use_limitations"] === undefined
        ? undefined
        : json["use_limitations"] === null
        ? null
        : json["use_limitations"],
    legalRestrictions:
      json["legal_restrictions"] === undefined
        ? undefined
        : json["legal_restrictions"] === null
        ? null
        : (json["legal_restrictions"] as Array<any>).map(LegalRestrictionFromJSON),
    equivalentScale:
      json["equivalent_scale"] === undefined
        ? undefined
        : json["equivalent_scale"] === null
        ? null
        : json["equivalent_scale"],
    resolution:
      json["resolution"] === undefined
        ? undefined
        : json["resolution"] === null
        ? null
        : json["resolution"],
    dataLanguage:
      json["data_language"] === undefined
        ? undefined
        : json["data_language"] === null
        ? null
        : ISO6392BFromJSON(json["data_language"]),
    topicCategory:
      json["topic_category"] === undefined
        ? undefined
        : json["topic_category"] === null
        ? null
        : json["topic_category"],
    spatialExtent:
      json["spatial_extent"] === undefined
        ? undefined
        : json["spatial_extent"] === null
        ? null
        : json["spatial_extent"],
    dataLineage:
      json["data_lineage"] === undefined
        ? undefined
        : json["data_lineage"] === null
        ? null
        : json["data_lineage"],
  };
}

export function ISO19115DatasetUpdateToJSON(json: any): ISO19115DatasetUpdate {
  return ISO19115DatasetUpdateToJSONTyped(json, false);
}

export function ISO19115DatasetUpdateToJSONTyped(
  value?: ISO19115DatasetUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    language: ISO6392BToJSON(value["language"]),
    parent_identifier: value["parentIdentifier"],
    metadata_contact: ResponsiblePartyToJSON(value["metadataContact"]),
    spatial_reference_system: value["spatialReferenceSystem"],
    data_citation: CitationUpdateToJSON(value["dataCitation"]),
    abstract: value["_abstract"],
    purpose: value["purpose"],
    status: StatusCodeToJSON(value["status"]),
    data_contact: ResponsiblePartyToJSON(value["dataContact"]),
    use_limitations: value["useLimitations"],
    legal_restrictions:
      value["legalRestrictions"] == null
        ? undefined
        : (value["legalRestrictions"] as Array<any>).map(LegalRestrictionToJSON),
    equivalent_scale: value["equivalentScale"],
    resolution: value["resolution"],
    data_language: ISO6392BToJSON(value["dataLanguage"]),
    topic_category: value["topicCategory"],
    spatial_extent: value["spatialExtent"],
    data_lineage: value["dataLineage"],
  };
}
